<script>
    import { each } from "svelte/internal";
    import { formatLocale } from "d3-format";

    export let type = "number";
    export let id;
    export let row;
    export let dataCharts;
    export let dataText;

    $: key = row.measure;
    // $: console.log("row", row);
    // $: console.log("key", key);
    // console.log("dataCharts", dataCharts);

    $: thisChart = dataCharts
        .map((e) => e[key])
        .filter((e) => e !== null && e !== undefined && e !== "");
    //   let max = row.yaxisend;
    //   let min = row.yaxisstart;
    //   let range = max - min;

    // console.log(thisChart, row.enddate);

    let chartWidth = 300,
        height = 110;
    let el;

    // UK locale so "$" in a format string renders as £ rather than $
    const ukLocale = formatLocale({
        decimal: ".",
        thousands: ",",
        grouping: [3],
        currency: ["£", ""]
    });

    let ukFormat;

    $: decimalPlacesRaw = row?.decimalPlaces ?? row?.decimalPlace;
    $: decimalPlaces = Number.isFinite(+decimalPlacesRaw)
        ? Math.max(0, Math.min(20, Math.trunc(+decimalPlacesRaw)))
        : 1;

    $: ukFormat = ukLocale.format(`$,.${decimalPlaces}f`);

    function formatWithDecimalPlaces(value) {
        const numberValue = +value;
        return Number.isFinite(numberValue)
            ? numberValue.toFixed(decimalPlaces)
            : value;
    }

    function formatShortMonthDate(value) {
        return String(value ?? "")
            .replace("Sep-", "Sept ")
            .replace("Jun-", "June ")
            .replace("Jul-", "July ")
            .replace("-", " ");
    }

    $: latestValue = thisChart.length > 0 ? thisChart[thisChart.length - 1] : 0;

    $: directLabelUnit =
        row?.directLabelUnit === null || row?.directLabelUnit === undefined
            ? ""
            : String(row.directLabelUnit).trim();

    $: hasDirectLabelUnit =
        directLabelUnit !== "" &&
        directLabelUnit.toLowerCase() !== "null" &&
        directLabelUnit.toLowerCase() !== "undefined";

    $: formattedValue = hasDirectLabelUnit && directLabelUnit.includes("£")
        ? ukFormat(latestValue)
        : formatWithDecimalPlaces(latestValue);

    $: suffix = !hasDirectLabelUnit
        ? ""
        : directLabelUnit.includes("£")
        ? ""
        : directLabelUnit.includes("%")
        ? directLabelUnit
        : " " + directLabelUnit;

    $: formattedEndDate = formatShortMonthDate(row?.enddate);

    $: formattedUpdate = formatShortMonthDate(row?.update).replace(/^0/, "")
        .replace(/\b(\d{2})$/, "20$1");
</script>

<div class="graphic" {id} bind:this={el} bind:clientWidth={chartWidth}>
    <!-- Chart heading text -->
    <div class="chartContainer">
        <p class="headingText">{row.headingtext}</p>
    </div>

    <svg class="chartDrawing" width="281">
        <!-- This bit draws the chart background -->
        <rect
            class="chartBackground"
            x="35"
            width={chartWidth - 104}
            height="110"
        ></rect>

        <!-- Big number and end date-->
        <text class="bigNo" x={chartWidth / 2 - 12} y={height / 2 + 6}>
            {formattedValue}{suffix}
        </text>
        <text
            class="bigDate"
            x={chartWidth / 2 - 12}
            y={height / 0.95}
            font-size={chartWidth < 290 ? "20px" : "22px"}
            >{formattedEndDate}</text
        >
    </svg>
    <p class="updated">Updated: {formattedUpdate}</p>
</div>